import { ROUTES } from '@futrli/shared-services';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { NotFound } from '../../errors/components/not-found';
import { ProductsManagementRedirect } from './products-management-redirect';
import { PredictConsolidationManagementContainer, PredictManagementContainer } from '@futrli/predict';

export const ProductsManagementRouter = ({ isConsolidation }: { isConsolidation?: boolean }): JSX.Element => {
  return (
    <React.Fragment>
      <Routes>
        <Route
          path={`${ROUTES.PRODUCT_SLUG}/*`}
          element={isConsolidation ? <PredictConsolidationManagementContainer /> : <PredictManagementContainer />}
        />

        <Route path="/" element={<ProductsManagementRedirect />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </React.Fragment>
  );
};
